import {RouterStateSnapshot, Routes} from '@angular/router';
import {NotFoundComponent} from "./components/not-found/not-found.component";
import {AuthPipeGenerator, canActivate, redirectLoggedInTo, redirectUnauthorizedTo} from "@angular/fire/compat/auth-guard";
import {RedirectGuard} from "./shared/guard/redirect-guard.service";
import {map} from "rxjs/operators";
import {isCustomDomain} from "./shared/helpers/portal-functions";

// Carry the route the user actually asked for into the sign-in URL so signing in continues to
// it instead of dropping the user on the dashboard home page. Passed as a string rather than a
// command array because the guard runs a string through Router.parseUrl(), which keeps it a
// query parameter that SignInComponent can read back off ActivatedRoute.
const redirectUnauthorizedToLogin: AuthPipeGenerator = (_next, state: RouterStateSnapshot) =>
    redirectUnauthorizedTo(`/dashboard/sign-in?returnUrl=${encodeURIComponent(state.url)}`);

const redirectLoggedInToItems = () => map(user => {
    const host = window.location.hostname;
    if (isCustomDomain(host)) {
        return true;
    }
    return user ? ['dashboard/home'] : true;
});


export const routes: Routes = [
    {
        path: '',
        loadChildren: () =>
            import('../routes/auth-routing.module').then(m => m.authRoutingModule),
        ...canActivate(redirectLoggedInToItems)
    },
    {
        path: '',
        loadChildren: () =>
            import('../routes/private-routing.module').then(m => m.privateRoutingModule),
        ...canActivate(redirectUnauthorizedToLogin)

    },
    {
        path: '404',
        component: NotFoundComponent,
    },
    {
        matcher: (url) => {
            const host = window.location.hostname;
            if (isCustomDomain(host)) {
                return {consumed: []};
            }
            return null;
        },
        loadChildren: () =>
            import('../routes/portal-routing.module')
                .then(m => m.portalRoutingModule)
    },
    {
        path: ':params',
        loadChildren: () =>
            import('../routes/portal-routing.module')
                .then(m => m.portalRoutingModule)
    },
    {
        path: '**',
        canActivate: [RedirectGuard],
        component: RedirectGuard,
        data: {
            externalUrl: 'https://www.koorvi.com/404'
        }
    },
];


